/* eslint-disable max-len */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-lines-per-function */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactGA from "react-ga4";
import { Button, Col, Empty, Row } from "antd";
import { Artifisettings } from "api/IProduct";
import { LoadingOutlined } from "@ant-design/icons";
import { Pagination } from "antd";
import { useAppSelector } from "hooks/reduxHooks";
import { AxiosResponse } from "axios";
import Heading from "components/Common/Heading/Heading";
import MyCollectionCard from "./MyCollectionCard";
import GroupNameFilter from "./AddOns/GroupNameFilter";
import { notificationController } from "components/Common/Notification/Notification";
import {
  deleteProductService,
  deleteProductServiceFromArtifi,
  getProductsService,
} from "api/services/product.api";
import {
  DeleteProductsBody,
  ProductListItem,
  SelectedCustomProducts,
} from "interfaces/ApiInterface/IProductGroupList";
import FallbackImage from "../../assets/Images/no-image.png";
import { ROUTES_PATH } from "routes/Routes.Constant";

interface MyCollectionProps {
  artifConfigurations: Artifisettings | undefined;
}

const MyCollection: React.FC<MyCollectionProps> = ({ artifConfigurations }: MyCollectionProps) => {
  const navigate = useNavigate();
  const publishCatalogId: number =
    useAppSelector((state) => state.landingPage.publishCatalogId) || 0;

  const userDetails = useAppSelector((state: any) => state.user.user);

  const antIcon = (
    <LoadingOutlined className="spinner" spin style={{ fontSize: "30px", color: "blue" }} />
  );

  const [selectedItemsToDelete, setSelectedItemsToDelete] = useState<string[]>([]);
  const [selectedItemsToDeleteFromArtifi, setSelectedItemsToDeleteFromArtifi] =
    useState<string>("");
  const [selectedItemsToShare, setSelectedItemsToShare] = useState<string[]>([]);
  const [selectedGroupName, setSelectedGroupName] = useState<string>("");
  const [selectedItemsObj, setSelectedItemsObj] = useState<SelectedCustomProducts[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [refreshGroupNameFilterList, setRefreshGroupNameFilterList] = useState<boolean>(false);
  const [productList, setProductList] = useState<ProductListItem[]>([]);
  const [pageProductList, setPageProductList] = useState<ProductListItem[]>([]);
  const [totalResults, setTotalResults] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [customisedProducts, setCustomisedProducts] = useState<any>([]);
  const itemPerPage = 30;

  useEffect(() => {
    localStorage.setItem("selectedItemsToShare", JSON.stringify(selectedItemsObj));
  }, [selectedItemsToShare]);

  const handleCheckboxChange = (product: any, isChecked: boolean): void => {
    const obj = {
      ZnodeMyLockerProductCustomizationDetailsId:
        product.ZnodeMyLockerProductCustomizationDetailsId,
      DesignId: product.DesignId,
    };
    setSelectedItemsToDeleteFromArtifi((prev: string): string => {
      if (prev) {
        return `${prev},${product.DesignId}`;
      }
      return product.DesignId;
    });

    setSelectedItemsToDelete((prevSelected: string[]) => {
      const pId = product?.ZnodeMyLockerProductCustomizationDetailsId?.toString();
      return isChecked ? [...prevSelected, pId] : prevSelected.filter((id: string) => id !== pId);
    });
    const index = selectedItemsObj.findIndex(
      (selectedItem) =>
        selectedItem.ZnodeMyLockerProductCustomizationDetailsId ===
          obj.ZnodeMyLockerProductCustomizationDetailsId &&
        selectedItem.ZnodeMyLockerProductCustomizationDetailsId ===
          obj.ZnodeMyLockerProductCustomizationDetailsId
    );

    if (index !== -1) {
      const selectedItemsObjCopy = [...selectedItemsObj];
      selectedItemsObjCopy.splice(index, 1);
      setSelectedItemsObj([...selectedItemsObjCopy]);
    } else {
      setSelectedItemsObj([...selectedItemsObj, obj]);
    }
    setSelectedItemsToShare((prevSelected: string[]) => {
      const designId = product?.DesignId?.toString();
      return isChecked
        ? [...prevSelected, designId]
        : prevSelected.filter((id: string) => id !== designId);
    });
  };

  const onHandleDeleteSelected = (): void => {
    if (selectedItemsToDelete.length === 0) {
      notificationController.error({
        message: "Please select at least one record",
      });
      return;
    }

    const body: DeleteProductsBody = {
      Ids: selectedItemsToDelete.join(", "),
    };

    ReactGA.event({
      category: "delete_button",
      action: "Delete design clicked",
      label: "Delete design clicked"
    });
    deleteProductService(body)
      .then(async (res: AxiosResponse) => {
        if (res && res?.data && res?.data?.IsSuccess === true) {
          notificationController.success({
            message: "Product items deleted successfully",
          });
          const updatedProductList = productList.filter(
            (product: ProductListItem) =>
              !selectedItemsToShare.includes(product?.DesignId?.toString())
          );
          setRefreshGroupNameFilterList(!refreshGroupNameFilterList);
          setProductList(updatedProductList);
          setSelectedItemsToDelete([]);
          setSelectedItemsToShare([]);
          setSelectedItemsObj([]);
          getProductList();
          const url = `${artifConfigurations?.Custom1}api/3/Design/DeleteDesigns?websiteId=${artifConfigurations?.WebsiteCode}&webApiClientKey=${artifConfigurations?.WebApiclientKey}&userId=${userDetails?.id}&designIds=${selectedItemsToDeleteFromArtifi}`;
          await deleteProductServiceFromArtifi(url);
        }
      })
      .catch((error: Error) => {
        throw error;
      });
  };

  const onHandleShareSelected = () => {
    if (!selectedItemsToShare.length) {
      notificationController.error({
        message: "Please select at least one record",
      });
    } else {
      ReactGA.event({
        category: "share_or_print_selected",
        action: "Share or print design",
        label: "Share or print design"
      });
      let query = "?";
      for (let i = 0; i < selectedItemsToShare.length; i++) {
        query += `design${i}=${selectedItemsToShare[i]}${
          selectedItemsToShare.length !== i + 1 ? "&" : ""
        }`;
      }
      navigate(`${ROUTES_PATH.SHARE_DESIGN_1}${query}`);
    }
  };

  /* Getting the product list of "My Collection" when we select group name from filter */
  const getProductList = async (groupName = "", isCreatedCustomProduct = false): Promise<void> => {
    getProductsService(groupName, publishCatalogId, currentPage)
      .then((res) => {
        setIsLoading(false);
        if (res) {
          if (res?.status === 200 && res?.data?.ProductList.length) {
            const sortedData = res?.data?.ProductList.sort(
              (a: any, b: any) =>
                b.ZnodeMyLockerProductCustomizationDetailsId -
                a.ZnodeMyLockerProductCustomizationDetailsId
            );
            setCustomisedProducts(res?.data?.ProductList);
            setProductList(sortedData);
            if (isCreatedCustomProduct) {
              setPageProductList(
                sortedData.slice((currentPage - 1) * itemPerPage, currentPage * itemPerPage)
              );
            } else {
              setPageProductList(sortedData.slice(0, itemPerPage));
            }
            setTotalResults(res.data.TotalResults);
          } else if (res?.status === 204) {
            setProductList([]);
            setPageProductList([]);
          }
        }
      })
      .catch((error: Error) => {
        setIsLoading(false);
        throw error;
      });
  };

  const onPageChange = (page: number) => {
    setPageProductList(productList.slice((page - 1) * itemPerPage, page * itemPerPage));
    setCurrentPage(page);
  };

  const isChecked = (designId: number) => {
    const checked = selectedItemsToDelete.filter((item: string) => +item === designId);
    if (checked.length > 0) return true;

    return false;
  };

  useEffect(() => {
    setIsLoading(true);
    setSelectedGroupName("");
  }, [currentPage]);

  useEffect(() => {
    if (publishCatalogId !== 0) getProductList();
  }, [currentPage, publishCatalogId]);

  const productListAvailable: boolean = productList && productList.length > 0;

  return (
    <div className="my-collection-wrapper">
      <Heading
        titleText="My Collection"
        titleClass="configuration-heading mb-3"
        data-test-selector="hdnMyCollection"
      />
      <Row gutter={[15, 15]} className="filter-sort mb-3">
        <Col span={4} xs={24} lg={4} xl={4} md={8}>
          <GroupNameFilter
            getProductList={getProductList}
            setSelectedGroupName={(groupName: string) => setSelectedGroupName(groupName)}
            selectedGroupName={selectedGroupName}
            refreshFilterList={refreshGroupNameFilterList}
          />
        </Col>
        <Col span={4} xs={12} lg={6} xl={4} xxl={4} md={8}>
          <Button
            type="primary"
            className="shareOrPrintBtn"
            onClick={onHandleShareSelected}
            disabled={!productListAvailable}
            data-test-selector="btnShareOrPrintSelected"
          >
            Share or Print Selected
          </Button>
        </Col>
        <Col span={4} xs={12} lg={4} xl={4} xxl={4} md={8}>
          <Button
            type="primary"
            className=""
            onClick={onHandleDeleteSelected}
            disabled={!productListAvailable}
            data-test-selector="btnDeleteSelected"
          >
            Delete Selected
          </Button>
        </Col>
      </Row>
      {isLoading ? (
        <Row gutter={[15, 15]} className="product-grid-wrapper loader-style">
          {antIcon}
        </Row>
      ) : pageProductList && pageProductList.length > 0 ? (
        <>
          <Row gutter={[15, 15]} className="product-grid-wrapper">
            {pageProductList.map((item: ProductListItem) => {
              let productImage = "";
              if (item?.ProductCustomizationJson && item?.ProductCustomizationJson.length > 0) {
                const arrProduct = JSON.parse(item?.ProductCustomizationJson);
                if (
                  item?.DesignType === "Artifi" &&
                  arrProduct?.previewThumbnailImages[0] != undefined
                ) {
                  productImage = arrProduct?.previewThumbnailImages[0];
                } else if (
                  item?.DesignType === "Rawlings" &&
                  (arrProduct?.previewWeb || arrProduct?.previewFront)
                ) {
                  productImage = arrProduct?.previewWeb || arrProduct?.previewFront;
                }
              }
              return (
                <Col
                  span={4}
                  xs={12}
                  md={8}
                  lg={4}
                  xl={4}
                  xxl={4}
                  key={item?.ZnodeMyLockerProductCustomizationDetailsId}
                >
                  <MyCollectionCard
                    isChecked={isChecked(item?.ZnodeMyLockerProductCustomizationDetailsId)}
                    imageUrl={productImage || FallbackImage}
                    titleText={item?.ConfigurationName}
                    groupText={item?.GroupName}
                    designId={item?.DesignId}
                    product={item}
                    modifiedDate={item?.ModifiedDate}
                    onCheckboxChange={handleCheckboxChange}
                    getProductList={getProductList}
                    groupName={selectedGroupName}
                    artifConfigurations={artifConfigurations}
                    customisedProducts={customisedProducts}
                    refreshGroupNameFilterList={refreshGroupNameFilterList}
                    setSelectedGroupName={setSelectedGroupName}
                    setRefreshGroupNameFilterList={setRefreshGroupNameFilterList}
                  />
                </Col>
              );
            })}
          </Row>
          <Row className="pagination-my-collection">
            <Pagination
              showSizeChanger={false}
              pageSize={itemPerPage}
              total={totalResults}
              defaultCurrent={currentPage}
              onChange={onPageChange}
            />
          </Row>
        </>
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}
    </div>
  );
};

export default MyCollection;
